<template>
  <div v-if="useItem">
    <el-row align="middle" type="flex" justify="center" :gutter="10">
      <el-col :sm="{span: 12}" :lg="{span: 12}">
        <el-popover class="hidden-xs-only" title="Disclamer" width="300" trigger="hover">
          <h1 slot="reference">
            {{useItem.Name}}
            <i class="el-icon-info el-icon-right"/>
          </h1>
          <p>{{useItem.Disclaimer}}</p>
          <a
            class="termslink"
            href="https://droplii.com/terms-of-use/"
            target="_blank"
          >Terms Of Service</a>
        </el-popover>
        <div class="hidden-sm-and-up">
          <h1>
            {{useItem.Name}}
            <i class="el-icon-info el-icon-right"/>
          </h1>
          <!-- <p>{{useItem.Disclaimer}}</p> -->
        </div>
        <el-collapse v-model="activeCollapse">
          <el-collapse-item title="Description" name="1">
            <!-- <div class="justify-text" v-html="getHtml(item.Description)"></div> -->

            <div class="justify-text">
              <p>{{useItem.Description}}</p>
            </div>
            <p></p>
          </el-collapse-item>
          <el-collapse-item v-loading="!recipes" title="Highest Voted Recipes" name="2">
            <div v-if="recipes && recipes.length >0">
              <div v-for="recipe in recipesInPage" :key="recipe.Id">
                <recipe-card
                  shadow="never"
                  @click.native="handleRecipeSelect(recipe)"
                  :recipe="recipe"
                />
                <br>
              </div>
              <el-pagination
                @current-change="handleCurrentChange"
                layout="prev, pager, next"
                :total="recipes.length * 3"
              ></el-pagination>
            </div>
            <div v-else-if="recipes && recipes.length === 0">
              <p>No Recipes yet..</p>
            </div>
          </el-collapse-item>
        </el-collapse>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import RecipeCard from '@/components/recipes/RecipeCard'
import { HTTP } from '@/http-common'
import { mapGetters } from 'vuex'
export default {
  name: 'selected-use-case',
  props: {
    categoryId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      activeCollapse: ['1', '2'],
      activeTab: 'Details',
      selectedRecipe: null,
      currentPage: 1,
      recipes: null
    }
  },
  computed: {
    ...mapGetters(['categories', 'user']),
    useItem() {
      return this.categories.find(u => u.Id === this.categoryId)
    },
    recipesInPage() {
      if (!this.recipes) return []
      const recipesPerPage = 3
      const startOfRecipes = recipesPerPage * (this.currentPage - 1)
      const endOfRecipes = recipesPerPage * this.currentPage
      return this.recipes.slice(startOfRecipes, endOfRecipes)
    }
  },
  methods: {
    handleRecipeSelect(recipe) {
      this.selectedRecipe = recipe //TODO check for favorites/votes updating and remove methods
    },
    handleCurrentChange(selected) {
      this.currentPage = selected
    },
    getRecipesForUse(useItem) {
      if (!useItem) return
      this.recipes = null
      HTTP.get('recipes/use/' + useItem.Id).then(response => {
        this.recipes = response.data
      })
    }
  },
  watch: {
    useItem: {
      handler: 'getRecipesForUse',
      immediate: true
    }
  },
  components: {
    RecipeCard
  }
}
</script>
<style scoped>
.justify-text {
  text-align: justify;
}
</style>

